import type { UIElement, ActionPayload } from '../../common/types.js';
import type { ChatUISpecRenderContext } from '../types.js';

interface InlineQuestionButtonEntry {
  label: string;
  action: ActionPayload;
}

export function renderInlineQuestionButtons(element: UIElement, ctx: ChatUISpecRenderContext): HTMLElement {
  const container = document.createElement('div');
  container.className = 'gengage-chat-inline-question-buttons';
  container.dataset['gengagePart'] = 'inline-question-buttons';

  const buttons = (element.props?.['buttons'] ?? []) as InlineQuestionButtonEntry[];
  for (const btn of buttons) {
    if (typeof btn?.label !== 'string' || !btn.label.trim()) continue;

    const button = document.createElement('button');
    button.className = 'gengage-chat-inline-question-btn gds-chip';
    button.dataset['gengagePart'] = 'inline-question-button';
    button.type = 'button';
    const icon = document.createElement('span');
    icon.className = 'gengage-chat-inline-question-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✦';

    const label = document.createElement('span');
    label.className = 'gengage-chat-inline-question-label';
    label.textContent = btn.label;

    button.append(icon, label);
    button.addEventListener('click', () => ctx.onAction(btn.action));
    container.appendChild(button);
  }

  return container;
}
